/**
 * How old the numbers on screen are, in words.
 *
 * Deliberately NOT `readAt` from coachCopy. That one states an absolute clock
 * time ("read 10:42") next to a specific figure, which is the right shape when
 * you are looking at the figure. The shell strip is persistent and sits above
 * every surface, so what it owes is the ELAPSED sense: a facilitator glancing at
 * it wants to know whether this is live or whether the poll has been failing,
 * and "updated 14 minutes ago" answers that where "updated 10:42" makes them do
 * arithmetic. Two different jobs, two formatters, no shared helper to drift.
 *
 * An absent or malformed timestamp returns the empty string and the caller drops
 * the clause entirely. Rendering "updated Invalid Date" would be worse than
 * saying nothing, and inventing "just now" from a missing value would be a lie.
 */

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;

export const freshnessLabel = (generatedAt, now = Date.now()) => {
  if (!generatedAt) return "";
  const at = new Date(generatedAt).getTime();
  if (Number.isNaN(at)) return "";

  // A timestamp from the future is clock skew, not a prediction. Clamp to zero
  // rather than rendering "updated in 3 minutes", which reads as a bug.
  const elapsed = Math.max(0, now - at);

  if (elapsed < MINUTE) return "updated just now";
  if (elapsed < HOUR) {
    const minutes = Math.floor(elapsed / MINUTE);
    return `updated ${minutes} minute${minutes === 1 ? "" : "s"} ago`;
  }
  const hours = Math.floor(elapsed / HOUR);
  return `updated ${hours} hour${hours === 1 ? "" : "s"} ago`;
};
